import { useQuery } from '@apollo/client';
import { GET_IT_APPLICATIONS_WORKAROUND_COMPLIANCE } from '../graphql';
import type {
  GetItApplicationsWorkaroundComplianceData,
  GetItApplicationsWorkaroundComplianceVars,
  WorkaroundComplianceMetric,
} from '../types';

/**
 * Hook to fetch applications workaround compliance
 * @param locationUUID - The UUID of the location to fetch the data for. If not provided, the data will be fetched for enterprise level.
 */
export const useApplicationsWorkaroundCompliance = (locationUUID?: string) => {
  const { data, loading, error } = useQuery<
    GetItApplicationsWorkaroundComplianceData,
    GetItApplicationsWorkaroundComplianceVars
  >(GET_IT_APPLICATIONS_WORKAROUND_COMPLIANCE, {
    variables: { locationUUID },
  });

  const metrics: WorkaroundComplianceMetric[] | undefined =
    data?.getITApplicationsWorkaroundCompliance?.map((metric) => ({
      ...metric,
      color: metric?.percentage === 100 ? '#3CB371' : undefined,
      isHighlighted: metric?.percentage === 100,
    }));

  return {
    data: metrics,
    loading,
    error,
  };
};
